// ==========================
// APP PROXY
// ==========================
const APP_PROXY_BASE = '/apps/bold-campaign';

// ==========================
// UTM UTILITIES
// ==========================
function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

// ==========================
// UTILIDADES CPF
// ==========================
function normalizeCPF(cpf) {
  return String(cpf).replace(/\D/g, '');
}

function isValidCPFFormat(cpf) {
  const clean = normalizeCPF(cpf);
  return clean.length === 11;
}

// ==========================
// UTILIDADES EMAIL
// ==========================
function isValidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}

// ==========================
// UTILIDADES TELEFONE
// ==========================
function normalizePhone(phone) {
  return String(phone).replace(/\D/g, '');
}

function isValidPhone(phone) {
  const clean = normalizePhone(phone);
  return clean.length === 11;
}

// ==========================
// HASH DO CPF (SHA-256)
// ==========================
async function hashCPF(cpf) {
  const cleanCPF = normalizeCPF(cpf);

  const encoder = new TextEncoder();
  const data = encoder.encode(cleanCPF);

  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

// ==========================
// LP FLOW
// ==========================
document.addEventListener('DOMContentLoaded', () => {

  const form = document.getElementById('lp-post-lead-form');
  if (!form) return;

  const cpfInput = form.querySelector('input[name="cpf"]');
  const phoneInput = form.querySelector('input[name="phone"]');

  // ==========================
  // FORMATAÇÃO TELEFONE
  // ==========================
  phoneInput.addEventListener('input', () => {
    let value = normalizePhone(phoneInput.value).slice(0, 11);

    if (value.length > 0) {
      value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
      value = value.replace(/(\d{5})(\d{4})$/, '$1-$2');
    }

    phoneInput.value = value;
  });

  // ==========================
  // FORMATAÇÃO CPF
  // ==========================
  cpfInput.addEventListener('input', () => {
    let value = cpfInput.value.replace(/\D/g, '').slice(0, 11);

    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

    cpfInput.value = value;
  });

  // ==========================
  // CAPTURA DE UTM
  // ==========================
  const utmFields = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
  ];

  utmFields.forEach((param) => {
    const value = getQueryParam(param);
    if (!value) return;

    const input = form.querySelector(`input[name="${param}"]`);
    if (input) input.value = value;
  });

  const loading = document.getElementById('lp-post-loading');
  const result = document.getElementById('lp-post-result');
  const button = document.getElementById('lp-post-submit');

  // ==========================
  // SUBMIT
  // ==========================
  button.addEventListener('click', async () => {

    const formData = new FormData(form);

    const name = formData.get('name');
    const email = formData.get('email');
    const phone = formData.get('phone');
    const cpf = formData.get('cpf');

    if (!isValidEmail(email)) {
      alert('Digite um e-mail válido.');
      return;
    }

    if (!isValidPhone(phone)) {
      alert('Digite um telefone válido com DDD.');
      return;
    }

    if (!isValidCPFFormat(cpf)) {
      alert('CPF inválido. Digite os 11 números.');
      return;
    }

    const utmData = {};
    utmFields.forEach((param) => {
      utmData[param] = formData.get(param) || null;
    });

    form.style.display = 'none';
    loading.style.display = 'block';

    const cpf_hash = await hashCPF(cpf);

    // Mantido apenas para compatibilidade com backend
    const drawNumber = Math.floor(Math.random() * 100) + 1;

    const payload = {
      campaign: 'mes_consumidor_2026',
      customer: {
        name,
        email,
        phone,
        cpf_hash
      },
      utm: utmData,
      client_draw: {
        number: drawNumber,
        range: 100
      }
    };

    try {

      const response = await fetch(`${APP_PROXY_BASE}/apps/bold-campaign/play`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Erro na resposta do backend');
      }

      const data = await response.json();

      loading.style.display = 'none';
      result.style.display = 'block';

      result.className = 'lp-result success';
      result.textContent = 'Cadastro realizado com sucesso! 🎉';

      setTimeout(() => {
        window.location.href = "/pages/semana-do-consumidor-obrigado";
        }, 1000);

/*
      // ==========================
      // EVENTO LEAD
      // ==========================
      if (!window.__leadTracked) {

        var eventID = 'lead_' + Date.now();

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'lead',
            event_category: 'Lead',
            event_label: 'LP Mes Consumidor 2026',
            campaign: 'mes_consumidor_2026',
            lead_email: email,
            event_id: eventID
          });
        }

        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', {}, {
            eventID: eventID
          });
        }

        window.__leadTracked = true;
      }
*/

      // ==========================
      // OCULTAR SEÇÃO
      // ==========================
      setTimeout(() => {
        const section = document.getElementById('lp-post-mes-consumidor');
        if (section) {
          section.style.display = 'none';
        }
      }, 1500);

    } catch (error) {

      loading.style.display = 'none';
      result.style.display = 'block';

      result.textContent =
        'Algo deu errado, mas fique tranquilo: seu cadastro foi recebido.';
    }
  });
});